import { CurrencyPipe } from '@angular/common';
import { BusinessFuel } from '../../business/models/business-fuel.model';
var FuelBadgeComponent = /** @class */ (function () {
    function FuelBadgeComponent(_currencyPipe) {
        this._currencyPipe = _currencyPipe;
    }
    Object.defineProperty(FuelBadgeComponent.prototype, "fuelText", {
        /**
         * Returns the text to display for fuel information
         */
        get: function () {
            return [
                this._currencyPipe.transform(this.fuel.price, 'USD'),
                BusinessFuel.formatFuelType(this.fuel.fuelType),
                BusinessFuel.formatServiceTypeShort(this.fuel.service)
            ].filter(function (v) { return v; }).join(' | ');
        },
        enumerable: true,
        configurable: true
    });
    return FuelBadgeComponent;
}());
export { FuelBadgeComponent };
